import { QuoteEntityType } from 'quotes/enums';

import { IVendorQuoteCreateForm } from './types';

export const mapCreateVendorQuoteForm = (
  data: IVendorQuoteCreateForm,
  entityType = QuoteEntityType.QUOTE
) => {
  const baseQuote = {
    projectId: data.project?.id,
    jobName: data.jobName,
    contactId: data.contact?.id,
  };

  switch (entityType) {
    case QuoteEntityType.ORDER:
      return {
        quote: {
          ...baseQuote,
          isOrder: 1,
          purchaseOrderNumber: data?.purchaseOrderNumber,
        },
        acceptTc: data?.agreeTermsAndConditions,
      };
    case QuoteEntityType.QUOTE:
    default:
      return {
        quote: {
          ...baseQuote,
          externalProjectName: data?.externalProjectName,
          externalNumber: data?.externalNumber,
          revisionNumber: data?.revisionNumber,
        },
      };
  }
};
